// Shared notification → translated text mapping.
//
// The ONE place the per-type copy lives. Both bells import it: the standalone
// /shared/notif-bell.js (maps/profile/auth pages) and the sounds bundle (which
// owns the bell on /sounds). Each bell keeps its OWN href/navigation — those
// differ by context on purpose (full hrefs vs in-SPA routing) — but the text,
// which was duplicated verbatim, now has a single source.
//
// `t` is the caller's translate function (key, params) → string.
export function notifText(n, t) {
  var d = n.data || {};
  switch (n.type) {
    case 'map_changeset_approved': return t('notif.cs_approved', { n: (d.approved != null ? d.approved : '') });
    case 'map_changeset_partial':  return t('notif.cs_partial', { a: (d.approved != null ? d.approved : 0), r: (d.rejected != null ? d.rejected : 0) });
    case 'map_changeset_rejected': return t('notif.cs_rejected');
    case 'map_poi_rejected':       return t('notif.map_rejected', { reason: (d.reason || '') });
    case 'challenge_beaten':       return t('notif.beaten', { who: (d.byPseudo || t('notif.someone')), score: (d.score != null ? d.score : '?') });
    case 'achievement_unlocked':   return t('notif.achievement', { name: t('srvach.' + String(d.achievementId || '').replace(/^srv\./, '') + '.title') });
    case 'loadout_invalid':        return t('notif.loadout_invalid', { name: (d.name || ''), to: (d.to || '') });
    case 'loadout_comment':        return t('notif.loadout_comment', { name: (d.name || ''), who: (d.by || t('notif.someone')) });
    case 'loadout_reply':          return t('notif.loadout_reply', { name: (d.name || ''), who: (d.by || t('notif.someone')) });
    case 'loadout_hidden':         return t('notif.loadout_hidden', { name: (d.name || '') });
    default:                       return t('notif.generic');
  }
}
